import SEO from '@/components/SEO';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import { useLanguage } from '@/contexts/LanguageContext';

const Cookies = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Cookies"
        description={t('Πολιτική cookies της TFT - Tesco Food Technology.', 'Cookie policy of TFT - Tesco Food Technology.')}
      />
      <Navigation />
      
      <main className="flex-1 py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl font-bold mb-8">
            {t('Πολιτική Cookies', 'Cookie Policy')}
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">
                {t('Τι είναι τα Cookies', 'What are Cookies')}
              </h2>
              <p className="text-muted-foreground">
                {t(
                  'Τα cookies είναι μικρά αρχεία κειμένου που αποθηκεύονται στη συσκευή σας όταν επισκέπτεστε έναν ιστότοπο. Χρησιμοποιούνται για να κάνουν τους ιστότοπους να λειτουργούν πιο αποτελεσματικά.',
                  'Cookies are small text files that are stored on your device when you visit a website. They are used to make websites work more efficiently.'
                )}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">
                {t('Πώς Χρησιμοποιούμε τα Cookies', 'How We Use Cookies')}
              </h2>
              <p className="text-muted-foreground">
                {t(
                  'Χρησιμοποιούμε cookies για να βελτιώσουμε την εμπειρία σας στον ιστότοπό μας, να θυμόμαστε τις προτιμήσεις σας και να αναλύουμε την επισκεψιμότητα του ιστότοπου.',
                  'We use cookies to improve your experience on our website, remember your preferences and analyze website traffic.'
                )}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">
                {t('Τύποι Cookies', 'Types of Cookies')}
              </h2>
              <p className="text-muted-foreground">
                {t(
                  'Χρησιμοποιούμε cookies περιόδου σύνδεσης (που λήγουν όταν κλείνετε το πρόγραμμα περιήγησης) και μόνιμα cookies (που παραμένουν στη συσκευή σας για καθορισμένο χρονικό διάστημα).',
                  'We use session cookies (which expire when you close your browser) and persistent cookies (which remain on your device for a specified period).'
                )}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">
                {t('Διαχείριση Cookies', 'Managing Cookies')}
              </h2>
              <p className="text-muted-foreground">
                {t(
                  'Μπορείτε να ελέγξετε και να διαχειριστείτε τα cookies μέσω των ρυθμίσεων του προγράμματος περιήγησής σας. Σημειώστε ότι η απενεργοποίηση των cookies μπορεί να επηρεάσει τη λειτουργικότητα του ιστότοπου.',
                  'You can control and manage cookies through your browser settings. Note that disabling cookies may affect the functionality of the website.'
                )}
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Cookies;
